{
  "tabs": {
    "chat": "Чат",
    "reminders": "Эскертүүлөр",
    "calendar": "Календарь",
    "settings": "Жөндөөлөр"
  },
  "common": {
    "cancel": "Жокко чыгаруу",
    "save": "Сактоо",
    "confirm": "Ырастоо",
    "delete": "Өчүрүү",
    "back": "Артка",
    "close": "Жабуу",
    "edit": "Түзөтүү",
    "search": "Издөө",
    "all": "Бардыгы",
    "loading": "Жүктөлүүдө...",
    "error": "Ката кетти",
    "notFound": "Табылган жок",
    "tryAgain": "Кайталап көрүңүз",
    "retry": "Кайталоо",
    "undo": "Кайтаруу",
    "pullToRefresh": "Жаңыртуу үчүн тарт",
    "justNow": "азыр эле"
  },
  "auth": {
    "welcome": "FishMemoryге кош келиңиз",
    "tagline": "Сиздин WhatsApp эскертүү жардамчыңыз, эми чөнтөгүңүздө.",
    "subtitle": "Сиздин WhatsApp эскертүү жардамчыңыз, эми чөнтөгүңүздө.",
    "phoneLabel": "Сиздин WhatsApp номериңиз",
    "phoneHint": "Биз WhatsApp аркылуу текшерүү кодун жиберебиз",
    "invalidPhone": "Туура телефон номерин киргизиңиз",
    "continue": "Улантуу",
    "enterPhone": "WhatsApp номериңизди киргизиңиз",
    "phonePlaceholder": "Телефон номери",
    "sendCode": "Код жиберүү",
    "verifyTitle": "Номерди текшерүү",
    "otpSentTo": "6 сандык код {{phone}} номерине WhatsApp аркылуу жиберилди",
    "enterFullCode": "Бардык 6 санды киргизиңиз",
    "invalidOtp": "Код туура эмес. Кайталап көрүңүз.",
    "otpFailed": "Код жиберүү мүмкүн болгон жок. Кайталап көрүңүз.",
    "otpResent": "Код кайра жиберилди",
    "resendIn": "{{seconds}}с ичинде кайра жиберүү",
    "resendCode": "Кодду кайра жиберүү",
    "enterOtp": "WhatsApp аркылуу келген кодду киргизиңиз",
    "verify": "Текшерүү",
    "resend": "Кодду кайра жиберүү",
    "wrongNumber": "Туура эмес номер?",
    "backToPhone": "Телефонго кайтуу",
    "editPhone": "Телефон номерин түзөтүү",
    "error": "Ката",
    "setupTitle": "Орнотууларды баштайлы",
    "setupSubtitle": "Бул параметрлерди кийин Жөндөөлөрдөн өзгөртө аласыз",
    "namePlaceholder": "Атыңыз",
    "letsGo": "Орнотууну бүтүрүү",
    "skipForNow": "Азыр өткөрүп жиберүү"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Кат жазуу...",
    "inputPlaceholder": "Кат жазуу...",
    "typing": "FishMemory жазып жатат...",
    "online": "Онлайн",
    "connecting": "Тиркелүүдө...",
    "reconnecting": "Кайра туташууда...",
    "offline": "Оффлайн",
    "empty": "Сүйлөшүүнү баштаңыз",
    "emptyHint": "Эскертүүлөрдү түзүңүз, графикти текшериңиз же жардам сураңыз.",
    "emptyAction": "Үлгү эскертүү жиберүү",
    "actions": "Чат аракеттери",
    "keep": "Каттарды сактоо",
    "clearTitle": "Чатты тазалоо",
    "clearConfirm": "Бул түзмөктөгү бардык каттарды өчүрүүбү? Бул калыбына келбейт.",
    "clear": "Чатты тазалоо",
    "optionSelected": "Тандалды: {{label}}",
    "sendingSelection": "Жөнөтүлүүдө...",
    "connectionLost": "Кайра туташууда..."
  },
  "reminders": {
    "title": "Менин эскертүүлөрүм",
    "active": "Активдүү",
    "today": "Бүгүн",
    "thisWeek": "Бул апта",
    "history": "Тарых",
    "items": "элементтер",
    "emptyTitle": "Азырынча эскертүүлөр жок",
    "emptySubtitle": "Чаттан түзүп, бул жерде көрүнөт.",
    "emptyAction": "Чатты ачуу",
    "filterActive": "Активдүү",
    "filterToday": "Бүгүн",
    "filterWeek": "Бул апта",
    "filterHistory": "Тарых",
    "emptyState": "Азырынча эскертүүлөр жок. Сүйлөшүүнү баштаңыз!",
    "swipeDone": "Аткарылды",
    "swipeSnooze": "Убакытты жылдыруу",
    "swipeDelete": "Өчүрүү",
    "search": "Эскертүүлөрдү издөө...",
    "upcoming": "Жакында",
    "completed": "Аткарылды",
    "overdue": "Мөөнөтү өттү",
    "tomorrow": "Эртең",
    "synced": "{{value}} синхрондолду",
    "swipeHint": "Кошумча аракеттер үчүн эскертүүнү жылдырыңыз",
    "noResults": "Издөө боюнча эскертүүлөр табылган жок",
    "noResultsHint": "Башка сөздү колдонуп көрүңүз же издөөнү тазалаңыз",
    "deleteAllFailed": "Бардык эскертүүлөрдү өчүрүү мүмкүн болгон жок"
  },
  "calendar": {
    "title": "Календарь",
    "today": "Бүгүн",
    "tomorrow": "Эртең",
    "completed": "аткарылды",
    "noEvents": "Жоспарланган иш жок",
    "noEventsSubtitle": "Эскертүүлөрдү жана календардык окуяларды көрүү үчүн күн тандаңыз.",
    "googleEvent": "Google Calendar",
    "legendActive": "Активдүү",
    "legendRecurring": "Кайталануучу",
    "legendDone": "Аткарылган",
    "legendGoogle": "Google",
    "previousMonth": "Мурунку ай",
    "nextMonth": "Кийинки ай",
    "previousYear": "Мурунку жыл",
    "nextYear": "Кийинки жыл",
    "goToToday": "Бүгүнгө өтүү",
    "all": "Бардыгы",
    "active": "Активдүү",
    "done": "Аткарылган",
    "paused": "Токтотулган"
  },
  "settings": {
    "title": "Жөндөөлөр",
    "profile": "Профиль",
    "name": "Көрсөтүлүүчү ат",
    "enterName": "Атыңызды киргизиңиз",
    "language": "Тил",
    "uiLanguage": "Колдонмо тили",
    "uiLanguageHelp": "Бул түзмөктө колдонмонун интерфейси, календарь жазуулары жана багытын өзгөртөт.",
    "serverLanguage": "Чат тили",
    "serverLanguageHelp": "Бул сиздин аккаунт үчүн сервер жоопторунда жана эскертүү билдирүүлөрүндө колдонулат.",
    "timezone": "Убакыт зонасы",
    "currentTimezone": "Учурдагы убакыт зонасы",
    "timezoneHelp": "Бардык эскертүү убакыттары ушул убакыт зонасында көрсөтүлөт.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Убакыт зонасын сактоо",
    "timezoneSaved": "Убакыт зонасы жаңыртылды",
    "detect": "Аныктоо",
    "detectFailed": "Убакыт зонасын аныктоо мүмкүн болгон жок",
    "autoDetect": "GPS аркылуу автоматтык аныктоо",
    "notifications": "Билдирмелер",
    "notificationsHelp": "Кийинки эскертүүлөр эскертүү берилгенден кийин кайталанган билдирүүлөрдү көзөмөлдөйт. Курал деңгээлиндеги уруксаттар телефон жөндөөлөрүндө башкарылат.",
    "pushEnabled": "Push билдирүүлөр",
    "autoDoneOnFire": "Аткарылганда автоматтык белгилөө",
    "autoDoneOnFireDesc": "Өчүрүлгөндө, эскертүүлөр сиз белгилегенче активдүү бойдон калат.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Туташкан",
    "googleDisconnected": "Туташкан эмес",
    "googleConnectedHelp": "Жаңы эскертүүлөр автоматтык түрдө календарга синхрондолот.",
    "googleDisconnectedHelp": "Google Calendarди туташтырып, эскертүүлөр менен окуяларды синхрондогула.",
    "googleConnectFailed": "Google Calendar туташуусу мүмкүн болгон жок",
    "connected": "Туташкан",
    "disconnected": "Туташкан эмес",
    "connect": "Туташтыруу",
    "disconnect": "Бөлүү",
    "autoSync": "Жаңы эскертүүлөрдү автоматтык синхрондоо",
    "autosync": "Жаңы эскертүүлөрдү автоматтык синхрондоо",
    "subscription": "Жазылуу",
    "trialUsed": "Сынамык: {{used}}/{{total}} колдонулду",
    "trialStatus": "Сынамык жеткиликтүү",
    "activeStatus": "Активдүү жазылуу",
    "expiredStatus": "Жазылуу мөөнөтү бүткөн",
    "unsubscribedStatus": "Жазылуу жок",
    "about": "Туурасында",
    "version": "Версия",
    "logout": "Чыгуу",
    "logoutTitle": "Чыгуу",
    "logoutConfirm": "Чыгууну каалайсызбы?",
    "noName": "Ат коюлган жок",
    "serverConnection": "Серверге туташуу",
    "serverUrl": "Сервер URL",
    "serverEdit": "Түзөтүү",
    "saveReconnect": "Сактоо жана кайра туташуу",
    "resetDefault": "Түзмө-түз калыбына келтирүү",
    "invalidServerUrlTitle": "Туура эмес сервер URL",
    "invalidServerUrlMessage": "Туура http же https сервер URL киргизиңиз, мисалы https://example.com",
    "uiLanguageChangeFailed": "Колдонмо тилин өзгөртүү мүмкүн болгон жок. Кайталап көрүңүз.",
    "serverLanguageChangeFailed": "Чат тилин өзгөртүү мүмкүн болгон жок. Кайталап көрүңүз.",
    "timezoneChangeFailed": "Убакыт зонасын өзгөртүү мүмкүн болгон жок. Кайталап көрүңүз.",
    "autoSyncChangeFailed": "Авто-синхрондоону жаңылоо мүмкүн болгон жок. Кайталап көрүңүз.",
    "nameChangeFailed": "Көрсөтүлүүчү атты жаңылоо мүмкүн болгон жок. Кайталап көрүңүз.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Эскертүү маалыматтары",
    "editTime": "Убакытты түзөтүү",
    "rename": "Атын өзгөртүү",
    "snooze": "Убакытты жылдыруу",
    "snooze15": "15 мүнөткө жылдыруу",
    "pause": "Токтотуу",
    "pauseReminder": "Эскертүүнү токтотуу",
    "resume": "Улантуу",
    "resumeReminder": "Эскертүүнү улантуу",
    "skip": "Кийинкисин өткөрүп жиберүү",
    "skipOccurrence": "Бул учурду өткөрүп жиберүү",
    "syncGoogle": "Google менен синхрондоо",
    "delete": "Өчүрүү",
    "deleteTitle": "Эскертүүнү өчүрүү",
    "deleteConfirm": "Бул эскертүү түбөлүккө өчүрүлөт.",
    "deleteRecurringTitle": "Кайталануучу эскертүүнү өчүрүү",
    "deleteRecurringMessage": "Бул учурду өткөрүп жибергиңизби же бүт серияны өчүрүңүзбү?",
    "deleteThisOccurrence": "Бул учурду өткөрүп жиберүү",
    "deleteEntireSeries": "Бүт серияны өчүрүү",
    "done": "Аткарылды",
    "markDone": "Аткарылды деп белгилөө",
    "undo": "Калыбына келтирүү",
    "undoPrompt": "Кайра активдүү кылгыңыз келеби? Азыр калыбына келтириңиз.",
    "recurring": "Кайталануучу",
    "nextRun": "Кийинки аткаруу",
    "oneTime": "Бир жолу",
    "pending": "Күтүлүүдө",
    "sent": "Жөнөтүлгөн",
    "paused": "Токтотулган",
    "active": "Активдүү",
    "snoozed": "Жылдырылган",
    "localTime": "Жергиликтүү убакытта көрсөтүлгөн",
    "recurrence": "Кайталануу",
    "created": "Жаралган",
    "tags": "Тегдер",
    "fireCount": "Жандырылган жолу",
    "actions": "Аракеттер",
    "none": "Жок",
    "snoozeFailed": "Эскертүүнү жылдыруу мүмкүн болгон жок",
    "pauseFailed": "Эскертүүнү токтотуу мүмкүн болгон жок",
    "resumeFailed": "Эскертүүнү улантуу мүмкүн болгон жок",
    "skipFailed": "Эскертүүнү өткөрүп жиберүү мүмкүн болгон жок",
    "doneFailed": "Эскертүүнү аткарылды деп белгилөө мүмкүн болгон жок",
    "undoFailed": "Эскертүүнү калыбына келтирүү мүмкүн болгон жок",
    "deleteFailed": "Эскертүүнү өчүрүү мүмкүн болгон жок",
    "rescheduleTitle": "Кайра пландаштыруу?",
    "rescheduleMsg": "Бул эскертүүнүн мөөнөтү өтүп кетти. Кайра пландаштырып бересизби?",
    "reschedule15": "15 мүнөттөн кийин",
    "reschedule60": "1 сааттан кийин",
    "keepOverdue": "Мурдагыдай калтыруу"
  },
  "onboarding": {
    "slide1Title": "FishMemoryге кош келиңиз",
    "slide1Sub": "Сиздин жеке эскертүү жардамчыңыз — WhatsApp менен иштейт жана чөнтөк үчүн түзүлгөн.",
    "slide2Title": "Табигый сүйлөшүү",
    "slide2Sub": "Мисалы: «Эртең саат 3тө апама чал деп эскертип коюңуз» — калганын биз жасайбыз.",
    "slide3Title": "Эч нерсени өткөрүп жибербеңиз",
    "slide3Sub": "Убакытында билдирүүлөрдү алыңыз, тегдер менен уюштуруңуз жана маанилүү нерселерди көзөмөлдөңүз.",
    "getStarted": "Баштоо",
    "next": "Кийинки",
    "firstReminderTitle": "Биринчи эскертүүңүздү түзүңүз!",
    "firstReminderHint": "Мисалы, мындай жазыңыз:",
    "firstReminderExample": "Эртең саат 9да суу ичүүнү эскертип коюңуз",
    "gotIt": "Түшүндүм!",
    "notifRationaleTitle": "Убакытында болуңуз",
    "notifRationaleBody": "FishMemory сизге убакытында эскертип туруу үчүн билдирүүлөрдү талап кылат. Сиз түзгөн эскертүүлөр үчүн гана билдирүүлөр келет.",
    "notifRationaleAllow": "Билдирүүлөрдү күйгүзүү",
    "notifRationaleLater": "Кийинчерээк",
    "swipeHint": "Ыкчам аракеттер үчүн оңго жылдырыңыз →",
    "calendarDragHint": "Кеңейтүү үчүн сүйрөңүз ↕"
  }
}
